/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./d-region.vue?vue&type=template&id=5aef682d&scoped=true"
import script from "./d-region.vue?vue&type=script&lang=js"
export * from "./d-region.vue?vue&type=script&lang=js"
import style0 from "./d-region.vue?vue&type=style&index=0&id=5aef682d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef682d",
  null
  
)

export default component.exports